import { Rebilly } from "components/PaymentMethods/Rebilly";

export const useCardProvider = () => {
  return { error: null, loading: false, Provider: Rebilly };
};
